export default __webpack_public_path__ + "static/Creative_community_badge-8708afec71f4f75e56c5b428163ba94b.svg";